import { render, staticRenderFns } from "./IncidentAlertEdit.vue?vue&type=template&id=27e87134"
import script from "./IncidentAlertEdit.vue?vue&type=script&lang=js"
export * from "./IncidentAlertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports